import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function MeetingDeleteConfirmation({ target, onOpenChange, onConfirm }) {
  const filename = target?.file?.original_filename;
  const title = target?.type === "recording" ? "Hapus Recording?"
    : target?.type === "minutes" ? "Hapus Manual Minutes?" : "Hapus Meeting?";
  const description = target?.type === "recording"
    ? `Recording “${filename}” akan dihapus permanen. Transcript dan analisis yang terkait juga akan dihapus.`
    : target?.type === "minutes"
      ? `Manual Minutes “${filename}” akan dihapus permanen. Analisis yang terkait juga akan dihapus.`
      : "Meeting ini akan dihapus permanen bersama semua Recording, Manual Minutes, transcript, dan hasil AI terkait. Tindakan ini tidak dapat dibatalkan.";

  return (
    <AlertDialog open={Boolean(target)} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-none">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-none">Batal</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            data-testid="confirm-delete-meeting-content"
            className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Hapus permanen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
